import { getLendingConfig } from './configs/claConfig';
import { getConstructionConfig } from './configs/constructionConfig';
import { getPaymentsConfig } from './configs/paymentsConfig';
import { getNativConfig } from './configs/nativConfig';

/*
 ** centralize the logic for config values for MFEs & create a SOLID access pattern to promote re-use in apps
 * Open/Closed principal
 */
const loadConfig = async (overrideConfig = undefined): Promise<void> => {
  if (overrideConfig) {
    window.ConfigUtility = overrideConfig;
  }
  if (!window.ConfigUtility) {
    const jsonUrl =
      System.resolve('@built/config-utility').split('/app.bundle.js')[0] +
      '/config.json';
    // eslint-disable-next-line no-restricted-properties
    const configJson = await System.import(jsonUrl);
    window.ConfigUtility = {
      ...configJson?.default,
    };
  }
};

export const ConfigModule = {
  getPaymentsConfig: getPaymentsConfig,
  getConstructionConfig: getConstructionConfig,
  getLendingConfig: getLendingConfig,
  getNativConfig: getNativConfig,
  loadConfig: loadConfig,
  //as we have more add here...
};
